exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2fXWF{width:72px;max-width:72px}._3n2Ar{width:88px;max-width:88px}._1h9ry{width:96px;max-width:96px}._1g0Sq{width:100px;max-width:100px}._17Zcb{width:112px;max-width:112px}._3fI2J{width:140px;max-width:140px}._9g19R{width:200px;max-width:200px}._2CEqn{width:256px;max-width:256px}", ""]);

// exports
exports.locals = {
	"w72": "_2fXWF",
	"w88": "_3n2Ar",
	"w96": "_1h9ry",
	"w100": "_1g0Sq",
	"w112": "_17Zcb",
	"w140": "_3fI2J",
	"w200": "_9g19R",
	"w256": "_2CEqn"
};